import fetch from 'cross-fetch';
import FlagProvider, { UnleashClient, InMemoryStorageProvider } from '@unleash/proxy-client-react';

import { isBrowser } from 'utils/isBrowser';
import { featureFlagConfig } from '../config';

const storageProvider = new InMemoryStorageProvider();

// Does not activate feature toggles unless unleashClient.start() is invoked
// Invoke it if ever needed toggle in SSR. Note that it might reduce performance
const unleashClient = new UnleashClient({ fetch, storageProvider, ...featureFlagConfig });

// This is necessary for mitigate unleash window error in SSR
const FlagProviderWrapper = ({ children }) => (
    <FlagProvider config={featureFlagConfig} unleashClient={!isBrowser && unleashClient}>
        {children}
    </FlagProvider>
);

export { FlagProviderWrapper };
